import {ChangeEvent, FormEvent, useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {
    Form,
    MainContainer,
    LoginContainer,
    LogoContainer,
    LeftContainer,
    RightContainer,
    AfterEmailSentContaier,
    ErrorMessage
} from './styles';
import api from '../../services/api';
import {ReactComponent as LogInImage} from '../../assets/images/log_in_image.svg';
import {ReactComponent as Logo} from '../../assets/images/logo.svg';
import React from 'react';
import {isValidEmail, isValidObject, isValidString} from "../../utils";
import {Checkbox, CheckboxLabel, InputText} from "../../components";

export const Login = () => {
    const [email, setEmail] = useState('');
    const [rememberMeChecked, setRememberMeChecked] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [emailSent, setEmailSent] = useState(false);
    const [emailValidationHelper, setEmailValidationHelper] = useState<{status: 'normal' | 'danger', text:string}>({
        status: 'normal',
        text: ''
    })

    const {t} = useTranslation();

    const handleEmailChange = (email:string) => {
        setEmailValidationHelper({
            status: isValidEmail(email) ? 'normal' : 'danger',
            text: isValidEmail(email) ? '' : t('invalid_email') as string
        })
        setEmail(email)
        setErrorMessage('')
    }

    async function handleSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault();
        try {
            const {data} = await api.post('/login/email', {
                email,
                keep_me_logged_in: rememberMeChecked
            });
            if(!data.hasOwnProperty('sent') || !data.sent){
                setErrorMessage(t('magic_link_error') as string);
                return;
            }
            setEmailSent(true);
            setErrorMessage('');
        } catch (err:any) {
            if(
                err.hasOwnProperty('response') &&
                isValidObject(err.response) &&
                err.response.hasOwnProperty('data') &&
                isValidObject(err.response.data) &&
                err.response.data.hasOwnProperty('error') &&
                err.response.data.error &&
                err.response.data.hasOwnProperty('message') &&
                isValidString(err.response.data.message)
            ){
                setErrorMessage(err.response.data.message);
                return;
            }
            setErrorMessage(t('magic_link_error') as string);
        }
    }

    const afterEmailSentContent = (
        <AfterEmailSentContaier>
            <h1>{t('welcome_back')}</h1>
            <p>
                <Trans i18nKey="we_sent_you_magic_link">
                    <a href="mailto:support@companio.co">link</a>
                </Trans>
            </p>
        </AfterEmailSentContaier>
    );

    return (
        <LoginContainer>
            <LeftContainer>
                <MainContainer>
                    <>
                        <LogoContainer>
                            <Logo/>
                        </LogoContainer>
                        {emailSent
                            ? afterEmailSentContent
                            : <Form action="" onSubmit={handleSubmit}>
                            <h1>{t('welcome_back')}</h1>
                            <p>{t('enter_email')}</p>
                            <InputText
                                id="input_email"
                                type="email"
                                value={email}
                                onChange={(e:ChangeEvent<HTMLInputElement>) => handleEmailChange(e.target.value)}
                                placeholder={t('enter_your_email') as string}
                                status={emailValidationHelper.status}
                                helperText={emailValidationHelper.text}
                            />
                            <button type="submit" disabled={!isValidEmail(email)}>{t('get_magic_link')}</button>
                                <CheckboxLabel htmlFor="input_remember_me" textSide="right">
                                    <Checkbox
                                        type="checkbox"
                                        id="input_remember_me"
                                        checked={rememberMeChecked}
                                        onChange={(e) => setRememberMeChecked(e.target.checked)}
                                    />
                                    {t('keep_me_logged_in')}
                                </CheckboxLabel>
                            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                        </Form>}
                    </>
                </MainContainer>
            </LeftContainer>

            <RightContainer>
                <LogInImage/>
            </RightContainer>
        </LoginContainer>
    );
}
